import React from 'react';
import styled from 'styled-components';
import breakpoints from '@rsc/ui-components/breakpoints';
import FacebookIcon from '@components/svgs/facebook-icon.svg';
import TwitterIcon from '@components/svgs/twitter-x.svg';
import PinterestIcon from '@components/svgs/pinterest-icon.svg';
import YoutubeIcon from '@components/svgs/youtube-icon.svg';
import InstagramIcon from '@components/svgs/instagram.svg';

const Container = styled.div`
  display: flex;
  flex-direction: row;
  margin-top: 2rem;
  justify-content: center;

  @media (min-width: ${breakpoints.lg}) {
    justify-content: flex-start;
  }

  a {
    line-height: normal;
    margin: 0 16px 5px 0;

    &:hover {
      #facebook {
        fill: #3b5999;
      }
      #twitter {
        fill: #55acee;
      }
      #pinterest {
        fill: #bd081c;
      }
      #youtube {
        fill: red;
      }
      #instagram {
        fill: #e4405f;
      }
    }
  }

  svg {
    width: 28px;
    height: 22px;
    transition: all 0.15s ease;
  }
`;

const socialList = [
  {
    id: 'facebook',
    icon: FacebookIcon,
    alt: 'Facebook Social Media Link',
    link: 'https://www.facebook.com/KurgoProducts',
  },
  {
    id: 'twitter',
    icon: TwitterIcon,
    alt: 'Twitter Social Media Link',
    link: 'https://twitter.com/kurgo',
  },
  {
    id: 'pinterest',
    icon: PinterestIcon,
    alt: 'Pinterest Social Media Link',
    link: 'https://pinterest.com/kurgoproducts/',
  },
  {
    id: 'youtube',
    icon: YoutubeIcon,
    alt: 'YouTube Social Media Link',
    link: 'https://www.youtube.com/user/KurgoProducts',
  },
  {
    id: 'instagram',
    icon: InstagramIcon,
    alt: 'Instagram Social Media Link',
    link: 'https://instagram.com/kurgo',
  },
];

const SocialIcons = () => (
  <Container>
    {socialList.map(element => (
      <div key={element.id}>
        <a
          href={element.link}
          target="_blank"
          rel="noreferrer"
          aria-label={element.alt}
        >
          <element.icon id={element.id} />
        </a>
      </div>
    ))}
  </Container>
);

export default SocialIcons;
